import React, { useState } from 'react';
import { X, Image as ImageIcon, CheckCircle } from 'lucide-react';

// --- 页面 6: AI分镜生成 (弹窗) ---
function StoryboardModal({ onNavigate }) {
  // 这个 state 模拟用户输入的文本
  const [prompt, setPrompt] = useState('');

  const handleGenerate = () => {
    // 导航到结果页, 并传递 prompt
    onNavigate('storyboard-result', { prompt });
  };

  return (
    // 弹窗容器
    <div className="absolute inset-0 z-20 flex items-center justify-center p-4">
      {/* 遮罩层 */}
      <div
        className="absolute inset-0 bg-black bg-opacity-70 backdrop-blur-sm z-30"
        onClick={() => onNavigate('home')} // 点击遮罩返回主页
      />
      
      {/* 对话框本身 */}
      <div className="relative z-40 bg-[#2a2a2e] rounded-lg shadow-2xl w-full max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
        
        {/* 左侧：输入表单 */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-white">
              输入你的创意想法，开始创作吧～
            </h2>
            <button
              onClick={() => onNavigate('home')} // 点击 "X" 返回主页
              className="text-gray-400 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <p className="text-sm text-gray-400">
            输入你想要生成的画面，例如：一个男人走在雨夜的街道，穿着风衣，很孤独
          </p>

          <textarea
            className="w-full h-24 p-2 bg-[#1e1e1e] border border-gray-600 rounded-md text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="请输入画面描述..."
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
          />

          <div className="flex items-center justify-between bg-[#1e1e1e] p-3 rounded-md">
            <span className="text-sm font-medium text-white">DeepVibe模型</span>
            <div className="w-10 h-5 bg-blue-500 rounded-full p-0.5 flex items-center">
              <div className="w-4 h-4 bg-white rounded-full shadow-md transform transition-transform translate-x-5" />
            </div>
          </div>

          <button 
            onClick={handleGenerate}
            className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors"
          >
            开始生成 (消耗12灵感值)
          </button>
        </div>

        {/* 右侧：设置 */}
        <div className="bg-[#1e1e1e] p-4 rounded-lg space-y-4">
          <h3 className="text-sm font-medium text-gray-300">已选画面比例</h3>
          <div className="p-3 bg-gray-700 rounded-md flex items-center space-x-2">
            <ImageIcon className="w-4 h-4 text-gray-400" />
            <span className="text-sm text-white">电影感 (16:9)</span>
          </div>
          
          <h3 className="text-sm font-medium text-gray-300">已选参考图</h3>
          <div className="p-3 bg-gray-700 rounded-md flex items-center space-x-2">
            <CheckCircle className="w-4 h-4 text-green-500" />
            <span className="text-sm text-white">已上传 (1)</span>
          </div>

          <button className="w-full py-2 border border-dashed border-gray-600 text-gray-400 rounded-lg hover:bg-gray-700 transition-colors">
            + 添加参考图
          </button>
        </div>

      </div>
    </div>
  );
}

export default StoryboardModal;
